export default "__VITE_ASSET__Ct_Jqa1m__"